var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6874 9.82508C13.4958 9.26675 14.0624 8.35008 14.0624 7.50008C14.0624 5.61675 12.6041 4.16675 10.7291 4.16675H5.52075V15.8334H11.3874C13.1291 15.8334 14.4791 14.4167 14.4791 12.6751C14.4791 11.4084 13.7624 10.3251 12.6874 9.82508ZM8.02075 6.25008H10.5208C11.2124 6.25008 11.7708 6.80841 11.7708 7.50008C11.7708 8.19175 11.2124 8.75008 10.5208 8.75008H8.02075V6.25008ZM10.9374 13.7501H8.02075V11.2501H10.9374C11.6291 11.2501 12.1874 11.8084 12.1874 12.5001C12.1874 13.1917 11.6291 13.7501 10.9374 13.7501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatBold);
export default __webpack_public_path__ + "static/media/format_bold.45d81a3dafb39bb3f714c90cadc4bc5d.svg";
export { ForwardRef as ReactComponent };